"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Wrapper = exports.Text = exports.StyledMarqueeItem = exports.MarqueeContainer = exports.ImageSvg = exports.Image = exports.Container = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _typography = require("@titelmedia/bricks-theme/lib/utilities/typography");
var _breakpoints = require("@titelmedia/bricks-theme/lib/variables/breakpoints");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Wrapper = _styledComponents.default.div`
  background-color: ${props => props.backgroundColor || 'transparent'};
  width: 100%;
  position: relative;
  margin: auto;
  overflow: hidden;
`;
exports.Wrapper = Wrapper;
const Container = _styledComponents.default.div`
  position: relative;
  height: ${props => props.desktopHeight || props.mobileHeight || '25vh'};
  @media (max-width: ${_breakpoints.BREAKPOINTS.md}px) {
    height: ${props => props.mobileHeight || '25vh'};
  }
`;
exports.Container = Container;
const StyledMarqueeItem = _styledComponents.default.div`
  position: absolute;
  width: auto;
  height: ${props => props.desktopHeight || props.mobileHeight || '25vh'};
  @media (max-width: ${_breakpoints.BREAKPOINTS.md}px) {
    height: ${props => props.mobileHeight || '25vh'};
  }
`;
exports.StyledMarqueeItem = StyledMarqueeItem;
const MarqueeContainer = _styledComponents.default.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: inherit;
`;
exports.MarqueeContainer = MarqueeContainer;
const Text = _styledComponents.default.p`
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  white-space: nowrap;
  ${props => (0, _typography.setFont)({
  bold: props.bold,
  display: !props.bold
})};
  text-transform: ${props => props.bold ? 'uppercase' : 'none'};
  line-height: 1em;
  color: ${props => props.fontColor || 'inherit'};
  ${props => {
  return (0, _typography.setFontSizes)({
    xs: props.bold ? '48px' : '48px',
    sm: props.bold ? '100px' : '100px',
    lg: props.bold ? '100px' : '100px'
  });
}};
`;
exports.Text = Text;
const Image = _styledComponents.default.img`
  ${props => props.text && `
    max-height: 60px;
    padding: 0px 8px;
    margin-top: ${props => {
  return props.bold ? '8px' : '-4px';
}};
    @media (min-width: ${_breakpoints.BREAKPOINTS.sm}px) {
      max-height: 90px;
      padding: 0px 16px;
    }
    @media (min-width: ${_breakpoints.BREAKPOINTS.md}px) {
      max-height: 120px;
    }
    `};
  ${props => !props.text && `
    max-height: 50vh;
      @media (min-width: ${_breakpoints.BREAKPOINTS.md}px) {
        max-height: 50vh;
      }
    `};
`;
exports.Image = Image;
const ImageSvg = _styledComponents.default.img`
  height: ${props => props.desktopHeight || props.mobileHeight || '25vh'};
  @media (max-width: ${_breakpoints.BREAKPOINTS.md}px) {
    height: ${props => props.mobileHeight || '25vh'};
  }
`;
exports.ImageSvg = ImageSvg;
//# sourceMappingURL=styles.js.map